import { UnitConvertible } from '@app/shared/units/base/unit-convertible';
import { flowFactors } from '@app/shared/units/flow/flow-factors';
import { FlowUnit } from '@app/shared/units/flow/flow-unit.enum';

export class Flow extends UnitConvertible<FlowUnit> {
  protected factors = flowFactors;
}
